import { Controller } from "@hotwired/stimulus"
import { textColorFromBackground } from "./colors"

export default class GooglePreviewBaseController extends Controller {
  static targets = [
    "googleCard", "googleInner", "googleHeader", "googleLogoZone", "googleLogoImg", "googleCardTitle",
    "googleTitleRow", "googleTitle", "googleTextRow", "googleTextLabel", "googleTextValue",
    "googleMidLabel", "googleMidValue",
    "googleStatusLabel", "googleStatusValue", "googleQr", "googleQrWrapper", "googleMember", "googleMemberText",
    "googleHero", "googleHeroImg",
  ]

  applyGooglePreview(data) {
    if (!this.hasGoogleCardTarget) return
    const bg = data.background_colour || "#ffffff"
    const textColor = textColorFromBackground(bg)
    if (this.googleCardTarget) this.googleCardTarget.style.backgroundColor = bg
    if (this.hasGoogleInnerTarget) this.googleInnerTarget.style.backgroundColor = bg
    if (this.hasGoogleHeaderTarget) this.googleHeaderTarget.style.color = textColor
    if (this.hasGoogleCardTitleTarget) this.googleCardTitleTarget.textContent = data.name || "Card name"
    if (this.hasGoogleTitleTarget) {
      this.googleTitleTarget.textContent = "Jane Pendlebury-Smith"
      this.googleTitleTarget.style.color = textColor
    }
    if (this.hasGoogleTextLabelTarget) this.googleTextLabelTarget.style.color = textColor
    if (this.hasGoogleTextValueTarget) this.googleTextValueTarget.style.color = textColor
    if (this.hasGoogleMidLabelTarget) this.googleMidLabelTarget.style.color = textColor
    if (this.hasGoogleMidValueTarget) this.googleMidValueTarget.style.color = textColor
    if (this.hasGoogleStatusLabelTarget) this.googleStatusLabelTarget.style.color = textColor
    if (this.hasGoogleStatusValueTarget) this.googleStatusValueTarget.style.color = textColor
    if (this.hasGoogleMemberTextTarget) this.googleMemberTextTarget.style.color = textColor
    if (this.hasGoogleQrTarget) this.googleQrTarget.style.backgroundColor = bg
    if (this.hasGoogleQrWrapperTarget) this.googleQrWrapperTarget.style.backgroundColor = bg
    const heroState = data.images?.hero
    this.setImageFromState(this.googleHeroImgTarget, heroState)
    this.applyHeroAspectRatioCap()
    if (this.hasGoogleCardTarget) {
      const heroFromForm = this.hasImageSource(heroState)
      const heroFromServer =
        this.googleHeroImgTarget?.src &&
        (this.googleHeroImgTarget.src.startsWith("http:") ||
          this.googleHeroImgTarget.src.startsWith("https:"))
      this.googleCardTarget.classList.toggle("card-preview--google-no-hero", !(heroFromForm || heroFromServer))
    }
    this.setImageFromState(this.googleLogoImgTarget, data.images?.logo)
  }

  applyHeroAspectRatioCap() {
    const img = this.hasGoogleHeroImgTarget ? this.googleHeroImgTarget : null
    const zone = this.hasGoogleHeroTarget ? this.googleHeroTarget : null
    if (!zone) return
    if (!img || !img.src || img.src === "#") {
      zone.classList.remove("card-preview__google-hero--capped")
      return
    }
    const onLoad = () => {
      const w = img.naturalWidth
      const h = img.naturalHeight
      const tooTall = w > 0 && h / w > 0.9
      zone.classList.toggle("card-preview__google-hero--capped", tooTall)
    }
    if (img.complete) {
      onLoad()
    } else {
      img.addEventListener("load", onLoad, { once: true })
    }
  }

  setImageSource(imgEl, url, file, previewDataUrl) {
    if (!imgEl) return
    this.releaseObjectUrl(imgEl)
    if (previewDataUrl) {
      imgEl.src = previewDataUrl
      this.showImage(imgEl)
      return
    }
    if (file) {
      const objectUrl = URL.createObjectURL(file)
      imgEl.dataset.objectUrl = objectUrl
      imgEl.src = objectUrl
      this.showImage(imgEl)
      return
    }
    if (url) {
      imgEl.src = url
      this.showImage(imgEl)
      return
    }
    this.hideImage(imgEl)
  }

  setImageFromState(imgEl, imageState) {
    const state = imageState || {}
    this.setImageSource(imgEl, state.url || null, state.file || null, state.previewDataUrl || null)
  }

  hasImageSource(imageState) {
    const state = imageState || {}
    return !!(state.url || state.file || state.previewDataUrl)
  }

  showImage(imgEl) {
    imgEl.classList.remove("d-none")
    imgEl.style.display = ""
  }

  hideImage(imgEl) {
    imgEl.removeAttribute("src")
    imgEl.classList.add("d-none")
    imgEl.style.display = ""
  }

  releaseObjectUrl(imgEl) {
    const objectUrl = imgEl?.dataset?.objectUrl
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl)
      delete imgEl.dataset.objectUrl
    }
  }

  releaseObjectUrls() {
    this.element.querySelectorAll("img[data-object-url]").forEach((img) => {
      this.releaseObjectUrl(img)
    })
  }
}
